import { render, staticRenderFns } from "./CopyrightAmendmentFormDetailsEscalated.vue?vue&type=template&id=1683d966&scoped=true&"
import script from "./CopyrightAmendmentFormDetailsEscalated.vue?vue&type=script&lang=js&"
export * from "./CopyrightAmendmentFormDetailsEscalated.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAmendmentFormDetailsEscalated.vue?vue&type=style&index=0&id=1683d966&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1683d966",
  null
  
)

export default component.exports